import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";

function useUtmParams() {
  const { utmParams } = useContext(AuthContext);
  return utmParams;
}

export default useUtmParams;
